import styled from 'styled-components';
import {
  COLOR,
  // FONT
} from 'assets';

export const CreatorGenreFormSec3Styled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  /* .item_init {
    .label {
      span {
        margin-left: 5px;
        color: ${COLOR.RED_1};
        &:hover {
          cursor: pointer;
        }
      }
    }
  } */
  .item_init {
    .label {
      background-color : ${COLOR.BLUE_5};
      padding : 3px 10px;
      margin : 0px 5px;
      color : ${COLOR.WHITE_1};
      border-radius : 5px;
    }
    span{
      margin-left : 10px;
      &:hover {
          cursor: pointer;
        }
    }
  }
  .box_label {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    @media only screen and (max-width:  600px) {
      display : block;
    }
    .label {
      min-width: 100px;
      margin-right: 10px;
    }
    .item_checkout {
      margin-right: 8px;
    }
  }
  .button_layer {
    text-align: right;
  }
  .genre_label{
    display : flex;
    @media only screen and (max-width:  600px) {
      display : block;
    }
    
  }
`;